import { Injectable } from '@angular/core';
import { BaseDataService } from '@core/service/base-data.service';
import { ListActionsService } from '@core/service/list-actions.service';
import { ManageUsers, ResetPassword, UserListFilterVm } from '../models/users.model';
import { Observable } from 'rxjs';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private apiUsers = 'api/Users'

  constructor(
    private baseDataService: BaseDataService,
    private listActionsService: ListActionsService
  ) { }

  /** Purges (permanently deletes) every user matching the given list filters. */
  purgeUsers(userListFilters?: UserListFilterVm): Observable<any> {
    return this.listActionsService.purgeList(this.apiUsers, userListFilters);
  }

  /** Requests a server-generated Excel export of every user matching the given list filters. */
  exportUsersToExcel(userListFilters?: UserListFilterVm): Observable<Blob> {
    return this.listActionsService.exportListToExcel(this.apiUsers, userListFilters);
  }

  getUsersList(): Observable<ManageUsers>{
    return this.baseDataService.makeGetCall(`${this.apiUsers}/getAllUsers`)
  }
  
  createUsers(user: ManageUsers) : Observable<any>{
    return this.baseDataService.makePostCall(`${this.apiUsers}`,user)
  }

  getUserById(id: string) : Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiUsers}/${id}`)
  }
  
  findUserByEmail(email: string) : Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiUsers}/findUserByEmail/${email}`)
  }
  
  updateUser(userReq: ManageUsers) : Observable<any>{
    return this.baseDataService.makePutCall(`${this.apiUsers}`,userReq)
  }

  getAllUsersList(userListFilters?: UserListFilterVm) : Observable<UserListFilterVm>{
    return this.baseDataService.makePostCall(`${this.apiUsers}/list`,userListFilters)
  }
  
  resetPassword(userId?: string,resetPassword?: ResetPassword) {
    return this.baseDataService.makePostCall(`${this.apiUsers}/change/password/${userId}`,resetPassword)
  }
  
  
  generate2FAQr(){
    return this.baseDataService.makeGetCall(`${this.apiUsers}/generate-2fa-qr`)
    
  }
  verifyOtp(otp:any){
    return this.baseDataService.makePostCall(`${this.apiUsers}/verify-2fa-otp`,otp)
    
  }
  verify2FAEnabled(){
    return this.baseDataService.makeGetCall(`${this.apiUsers}/verify/2fa/enable`)
    
  }
  enable2FA(enable:boolean){
    return this.baseDataService.makeGetCall(`${this.apiUsers}/enable/2fa?enable=`+enable)
    
  }

  getAssignedOrganization() : Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiUsers}/organizations`)
  }
}
